<template>
    <div>
        <a v-bind:href="url" target="_new">
            <button
                class="btn btn-primary btn-sm"
                data-toggle="tooltip"
                data-placement="top"
                >
                <i class="glyphicon glyphicon-play"></i>
            </button>
        </a>
    </div>
</template>
<script>
    export default {
        props: {
            data: Object
        },
        data () {
            let token = this.$store.state.token
            token = token.replace('Bearer ', '')
            let type = this.data.path.split('/')[1]
            return {
                url: '/static/robot/robot.html?name=' + this.data.fileName + '&token=' + token + '&type=' + type
            }
        },
        watch: {
            data: function (newVal, oldVal) {
                let token = this.$store.state.token
                token = token.replace('Bearer ', '')
                let type = this.data.path.split('/')[1]
                this.url = '/static/robot/robot.html?name=' + this.data.fileName + '&token=' + token + '&type=' + type
            }
        },
        mounted () {
        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// ListMotionFileAction.vue?11328514